import './styles/Footer.css';
import ReactPixel from 'react-facebook-pixel';

function Footer() {

      const handleClickContato = () => {
        ReactPixel.trackCustom('ClickWhatsAppCTA', {
          action: 'Clique Contato Footer',
          origem: 'Seção FAQ',
        });
        ReactPixel.trackCustom('Lead', {
          action: 'Clique Contato Footer',
          origem: 'Seção Footer',
        });
        window.open('https://w.app/pjvwxy', '_blank');
      };

      const handleClickSobre = () => {
        ReactPixel.trackCustom('ClickSobre', {
          action: 'Clique Sobre Footer',
          origem: 'Seção Footer',
        });
        window.open('https://grupobiosafe.com.br/sobre', '_blank');
      };

      const handleClickTraining = () => {
        ReactPixel.trackCustom('ClickTreinamentos', {
          action: 'Clique Treinamentos Footer',
          origem: 'Seção Footer',
        });
        window.open('https://grupobiosafe.com.br/treinamentos', '_blank');
      };

      const handleClickLogo = () => {
        ReactPixel.trackCustom('ClickLogo', {
          action: 'Clique Logo Footer',
          origem: 'Seção Footer',
        });
        window.open('https://www.grupobiosafe.com.br/', '_blank');
      };


    return (
        <div className="footer">
            <div className="left">
                <div className="logobiosafe" onClick={handleClickLogo} role="button" tabIndex={0} aria-label="Ir para o site do Grupo Biosafe" onKeyDown={(e) => e.key === 'Enter' && handleClickLogo()}></div>
                <p onClick={handleClickTraining} role="button" tabIndex={0} onKeyDown={(e) => e.key === 'Enter' && handleClickTraining()}>Cursos</p>
                <p onClick={handleClickSobre} role="button" tabIndex={0} onKeyDown={(e) => e.key === 'Enter' && handleClickSobre()}>Conheça-nos</p>
                <p onClick={handleClickContato} role="button" tabIndex={0} onKeyDown={(e) => e.key === 'Enter' && handleClickContato()}>Contato</p>
            </div>
            <div className="right">
                <a href="https://www.skyzdesign.com.br/" target='_blank' rel='noreferrer'><p>Designed by: @skyzdesignbr</p></a>
            </div>
        </div>
    )
};

export default Footer;